<div class="flex-row space-between" id="link-bank_container">
  <h1 id="link-bank_title">{{ 'COMMON.BUTTON.LINK_ANOTHER_BANK' | translate }}</h1>
  <a id="link-bank_href" [routerLink]="urlPath">
    <pbb-svg-icon
      [icon]="'add-btn'"
      [title]="'COMMON.BUTTON.LINK_ANOTHER_BANK_ADD' | translate"
      class="icon-md"
    ></pbb-svg-icon>
  </a>
</div>
<div class="flex-row mt-24"></div>
